import { useEffect, useState } from 'react';
import { MOBILE_WIDTH } from "@/resources/constants";
import styles from "@/styles/components/featuredGrid.module.scss";
import GradientTitle from '@/components/SolutionsTemplate/GradientTitle';

interface Props {
    type: string;
    jsonData: any;
}

interface GridItemProps {
    componentType: string;
    type: string;
    title: string;
    description: string;
    image: string;
    isMobile: boolean;
}

function GridItem({ componentType, type, title, description, image, isMobile }: GridItemProps) {

    var backgroundColour = "";

    if(componentType === "retail")
        backgroundColour = "rgba(247, 162, 133, 0.05)";

    else if(componentType === "transportation")
        backgroundColour = "rgba(97, 188, 142, 0.05)";

    else if(componentType === "industries")
        backgroundColour = "rgba(200, 145, 248, 0.05)";

    function fadeTransition() {

        if(componentType === "retail")
            return(`
                transparent 0%,
                rgba(40, 35, 42, 0.05) 20%,
                rgba(40, 35, 42, 0.15) 40%,
                rgba(40, 35, 42, 0.35) 65%,
                rgba(40, 35, 42, 1.0) 100%
            `)
        
        if(componentType === "transportation")
            return(`
                transparent 0%,
                rgba(35, 39, 45, 0.05) 20%,
                rgba(35, 39, 45, 0.15) 40%,
                rgba(35, 39, 45, 0.35) 65%,
                rgba(35, 39, 45, 1.0) 100%
            `)

        if(componentType === "industries")
            return(`
                transparent 0%,
                rgba(39, 37, 50, 0.05) 20%,
                rgba(39, 37, 50, 0.15) 40%,
                rgba(39, 37, 50, 0.35) 65%,
                rgba(39, 37, 50, 1.0) 100%
            `)
    }

    return (
        <div 
            className = {styles.gridItemDiv}
            style = {{
                backgroundColor: backgroundColour,
                overflow: "hidden",
                flexDirection: (type === "left" ? "column" : "row"),
            }}>
            <div style = {{
                padding: "40px",
                zIndex: "-1",
                flex: (isMobile ? "1" : "1"),
                //border: "1px solid green",
            }}>
                <GradientTitle 
                    text = {title}
                    fontSize = {"30px"}
                    fontWeight = {"400"}/>
                <div className = {styles.gridItemDescription}>{description}</div>
            </div>
            {image && !isMobile && (
                <div 
                    className = {styles.gridItemImageGradientDiv}
                    style = {{
                        flex: (type === "left" ? "50" : "1"),
                        flexGrow: "1",
                        objectFit: "cover",
                        overflow: "visible",
                        zIndex: "20",
                        //border: "1px solid red",
                    }}>
                    <div 
                        className={styles.gridItemImage}
                        style = {{
                            backgroundImage: `
                                linear-gradient(${type === "left" ? "to top" : "to left"}, ${fadeTransition()}),
                                ${image}
                            `,
                            backgroundRepeat: "no-repeat",
                            backgroundSize: "cover", 
                            backgroundPosition: "center",
                            height: "100%"
                        }} />
                </div>
            )}
        </div>
    );
}

export default function FeaturedGrid({type, jsonData}: Props){

    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= (MOBILE_WIDTH + 200)); // Adjust the width threshold as needed
        };

        handleResize(); // Check on initial render
        window.addEventListener("resize", handleResize);

        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    function getLightEffectClass(){
        if(type === "retail")
            return "light_effect_card_retail";
        else if(type === "transportation")
            return "light_effect_card_transport";
        else if(type === "industries")
            return "light_effect_card_industry";
        return "light_effect_card";
    }

    return(
        <div className = {isMobile ? styles.rootDivMobile : styles.rootDiv}>
            {jsonData.map((item: any, index: number) => (
                <div
                    className={`${getLightEffectClass()} ${styles.card} ${isMobile ? "" : (index === 0 ? styles.leftItem : (index === 1 ? styles.topItem : ""))}`}
                    style = {{
                        overflow: "hidden",
                        padding: "1px",
                        flexBasis: (isMobile ? "100%" : "")
                    }}>
                    <GridItem
                        key = {index}
                        componentType = {type}
                        type = {item.type}
                        title = {item.title}
                        description = {item.description}
                        image = {item.image}
                        isMobile = {isMobile}/>
                </div>
            ))}
        </div>
    )
}